export default class Tab {
	constructor(els) {
		this.els = document.querySelectorAll(els);
	}

	init() {
		if (!this.els.length) {
			return;
		}

		[...this.els].forEach((el) => {
			const buttons = el.querySelectorAll(':scope > .tab__list [aria-controls]');
			const tabPanels = el.querySelectorAll(':scope > .tab__content > [role="tabpanel"]');

			this._setWaiAria(buttons, tabPanels);

			buttons.forEach((button) => {
				this._clickButton(button, buttons, tabPanels);
			});

			this._controlByKeyboard(buttons, tabPanels);

			this._openPanelPageByParameter(el, buttons, tabPanels);
		});
	}

	_clickButton(button, buttons, tabPanels) {
		button.addEventListener('click', (e) => {
			this._activate(button, buttons, tabPanels);
		});
	}

	_setWaiAria(buttons, tabPanels) {
		buttons.forEach((button, i) => {
			if (button.getAttribute('aria-selected') === 'true') {
				button.setAttribute('tabindex', '0');
				tabPanels[i].removeAttribute('hidden');
			} else {
				button.setAttribute('tabindex', '-1');
				button.setAttribute('aria-selected', 'false');
				tabPanels[i].setAttribute('hidden', 'until-found');
				tabPanels[i].removeAttribute('tabindex');
			}
		});
	}

	_activate(button, buttons, tabPanels) {
		buttons.forEach((button) => {
			button.setAttribute('aria-selected', 'false');
			button.setAttribute('tabindex', '-1');
		});

		button.setAttribute('aria-selected', 'true');
		button.setAttribute('tabindex', '0');
		button.focus();

		const target = button.getAttribute('aria-controls');
		tabPanels.forEach((tabPanel) => {
			if (tabPanel.id === target) {
				tabPanel.removeAttribute('hidden');
				tabPanel.setAttribute('tabindex', '0');
			} else {
				//tabPanel.hidden = true;
				tabPanel.setAttribute('hidden', 'until-found');
				tabPanel.removeAttribute('tabindex');
			}
		});

		requestAnimationFrame(() => {
			window.dispatchEvent(new Event('resize'));
		});
	}

	_controlByKeyboard(buttons, tabPanels) {
		buttons.forEach((button) => {
			button.addEventListener('keydown', (e) => {
				const currentIndex = [...buttons].indexOf(document.activeElement);

				switch (e.key) {
					case 'ArrowRight':
						e.preventDefault();
						if (currentIndex + 1 < buttons.length) {
							buttons[currentIndex + 1].focus();
						}
						break;
					case 'ArrowLeft':
						e.preventDefault();
						if (currentIndex - 1 >= 0) {
							buttons[currentIndex - 1].focus();
						}
						break;
					case 'Home':
						e.preventDefault();
						buttons[0].focus();
						break;

					case 'End':
						e.preventDefault();
						buttons[buttons.length - 1].focus();
						break;
				}
			});
		});

		tabPanels.forEach((tabPanel) => {
			tabPanel.addEventListener('beforematch', () => {
				const currentIndex = [...tabPanels].indexOf(tabPanel);

				this._activate(buttons[currentIndex], buttons, tabPanels);
			});
		});
	}

	_openPanelPageByParameter(el, buttons, tabPanels) {
		const query = location.search;
		//console.log(query);

		if (!query) {
			return;
		}

		const urlParams = new URLSearchParams(query);

		//console.log(urlParams);
		const tabName = urlParams.get('tab');

		// const id = param.replace('#', '');
		const button = el.querySelector(`:scope > .tab__list [aria-controls="${tabName}"]`);

		if (button) {
			this._activate(button, buttons, tabPanels);
		}
	}
}
